import { SUGGESTION_TYPES } from '@/features/shared/constants/global'
// Do not remove in favor of design system
// We will lose continuity w/ Mobile
import { HighDemandIcon, HistoryIcon, RatingStarIcon, SearchIcon } from '@shipt/design-system-icons'

const {
  STANDARD,
  POPULAR,
  PERSONALIZED_RECENT,
  PERSONALIZED_RECENT_IMAGE,
  PERSONALIZED_POPULAR,
  PERSONALIZED_POPULAR_IMAGE,
} = SUGGESTION_TYPES

export const getSuggestionIcon = (type: string) => {
  switch (type) {
    case POPULAR:
      return HighDemandIcon
    case PERSONALIZED_RECENT:
      return HistoryIcon
    case PERSONALIZED_POPULAR:
      return RatingStarIcon
    case STANDARD:
    default:
      return SearchIcon
  }
}

export const getSuggestionTypeText = (type: string): string => {
  switch (type) {
    case PERSONALIZED_RECENT_IMAGE:
    case PERSONALIZED_RECENT:
      return 'Recent'
    case PERSONALIZED_POPULAR_IMAGE:
    case PERSONALIZED_POPULAR:
      return 'Your popular searches'
    default:
      return ''
  }
}

export const getIsImageType = (type: string) => {
  // the current BE pattern is to append "_image" to
  // any existing type if it is meant to contain an image
  return type.endsWith('_image')
}
